export default {
  data() {
    return {
      solutionList: [{
        title: '证券解决方案',
        desc: '为券商提供技术架构到平台、数据，再到内容、营销、运营、人工智能等系统工具服务，主力金融机构低成本实现产品建设、用户增长及资产提升',
        path: '/solution/SecuritiesSolutions',
        img: require('@/assets/images/homepage/solution1.png')
      }, {
        title: '医疗解决方案',
        desc: '专注于图相处理、NLP等技术在医疗健康领域的研发与应用，打造了AI图像辅导诊断、AI语音医疗助手和AI科研三大产品体系',
        path: '/solution/HealthcareSolutions',
        img: require('@/assets/images/homepage/solution2.png')
      }]
    };
  }
};